// features/CustomerManagement/ExportModal.js
import React, { useState } from 'react';
import { Modal, Button, Checkbox, Row, Col, DatePicker, Select } from 'antd';
import { exportToCSV } from '../../utils/helper';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ExportModal = ({ 
  visible, 
  customers,
  statusOptions,
  onCancel 
}) => {
  const [selectedFields, setSelectedFields] = useState([
    'name', 'email', 'phone', 'status', 'orders', 'tags', 'createdAt'
  ]);
  const [dateRange, setDateRange] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState(['Active', 'Inactive']);

  const handleExport = () => {
    // Filter customers based on selected filters
    let filteredCustomers = [...customers];
    
    // Apply date filter
    if (dateRange.length === 2) {
      filteredCustomers = filteredCustomers.filter(customer => {
        const customerDate = new Date(customer.createdAt);
        return customerDate >= dateRange[0] && customerDate <= dateRange[1];
      });
    }
    
    // Apply status filter
    if (selectedStatuses.length > 0) {
      filteredCustomers = filteredCustomers.filter(customer => 
        selectedStatuses.includes(customer.status)
      );
    }
    
    // Prepare CSV data
    const csvData = filteredCustomers.map(customer => ({
      name: `${customer.first_name} ${customer.last_name}`,
      email: customer.email,
      phone: customer.shipping_address?.[0]?.phone || customer.orders?.[0]?.customer_info?.phone || '',
      status: customer.status,
      orders: customer.orders?.length || 0,
      tags: customer.tags?.join('; ') || 'no tags',
      createdAt: new Date(customer.createdAt).toLocaleString(),
      totalSpent: customer.orders?.reduce((sum, order) => sum + order.totalAmount, 0) || 0
    }));
    
    // Generate filename with timestamp
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const filename = `customers_export_${timestamp}.csv`;
    
    // Trigger download
    exportToCSV(csvData, filename);
    onCancel();
  };

  return (
    <Modal
      title="Export Customer Data"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={handleExport}
        >
          Export to CSV
        </Button>
      ]}
    >

      <div className="mb-4">
        <h4 className="font-medium mb-2">Filter by Date Range</h4>
        <RangePicker 
          style={{ width: '100%' }}
          onChange={setDateRange}
        />
      </div>

      <div>
        <h4 className="font-medium mb-2">Filter by Status</h4>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Select statuses"
          defaultValue={['Active', 'Inactive']}
          onChange={setSelectedStatuses}
        >
          {statusOptions.map(status => (
            <Option key={status.value} value={status.value}>
              {status.label}
            </Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

export default ExportModal;